import useNavigationStore from "@src/stores/navigationStore";
import Documents from "./Documents";
import Identity from "./Identity";
import ProofOfAddress from "./ProofOfAddress";
import CompanyDocuments from "./CompanyDocuments";
import Overview from "./Overview";
import Signature from "./Signature";
import BeneficiariesDocuments from "./BeneficiariesDocuments";

const componentMap = {
    Documents: Documents,
    Identity: Identity,
    ProofOfAddress: ProofOfAddress,
    BeneficiariesDocuments: BeneficiariesDocuments,
    CompanyDocuments: CompanyDocuments,
    Overview: Overview,
    Signature: Signature
};

export default function SixthSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
